export default __webpack_public_path__ + "static/media/package.39bed5ea.webp";